export default __webpack_public_path__ + "static/media/quienesSomos2.89f8e5a1.jpg";